// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {
  router
} from './router'
import elementui from 'element-ui'
import './assets/scss/element-variables.scss'
import './assets/scss/main.scss'
import 'axios'
import vuex from 'vuex'
import state from '@/vuex/states'
import mutations from '@/vuex/mutations'
import actions from '@/vuex/actions'
import {setCookie,getCookie,delCookie} from './assets/cookie'
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

Vue.prototype.$cookieStore = {setCookie,getCookie,delCookie}

// 路由跳转后返回页面顶端
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

Vue.config.productionTip = false;
Vue.use(elementui, {
  size: 'mini'
});
Vue.use(vuex);

const store = new vuex.Store({
  state,
  mutations,
  actions
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js